module.exports = __webpack_public_path__ + "img/sample14.147089d7.jpg";